/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.4.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationCommon } from '../../modules/internationalization/intSelectors';
import ICommonTranslation from '../../modules/internationalization/types/common';
import { IRootReducer } from '../../reducers/rootReducer';
import { icons } from '../../theme';
import ErrorPage from './ErrorPage';

export interface IConnectedProps {
    translation: ICommonTranslation;
}

export const PageForbidden = ({ translation }: IConnectedProps) =>
    <ErrorPage
        src={icons.errorDeliveryImage3x}
        text={translation.error.forbidden.text}
        title={translation.error.forbidden.title}
    />;

const mapConnectToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapConnectToProps)(PageForbidden);
